import { defaultModelLabel } from '../../../models/model-labels';

/**
 * Build the assistant-text rewriter: rewrite recognized model-id mentions
 * (e.g. `anthropic.claude-opus-4-8`) to the same native friendly name the
 * picker shows, so chat text and the picker never disagree. Tokens the native
 * table doesn't recognize pass through unchanged.
 */
export function makeModelMentionRewriter(): (content: string) => string {
  return (content) =>
    content.replace(/[A-Za-z0-9](?:[\w.:-]*[A-Za-z0-9])?/gu, (token) => {
      const label = defaultModelLabel(token);
      return label.length > 0 && label !== token ? label : token;
    });
}
